/**
 * Single source of truth for the backend API host and third-party keys.
 *
 * To switch environment:
 *   1. Preferred - set REACT_APP_ENV in the .env file (dev | uat | live | prod),
 *      or set REACT_APP_API_BASE_URL to point at any other host.
 *   2. Fallback   - change DEFAULT_ENV below.
 *
 * Either way a rebuild is required, because CRA inlines env vars at build time.
 *
 * Do NOT hardcode an API host anywhere else in the app - always import BASE_URL.
 */

const API_HOSTS = {
  dev: "https://laundrygoapps.24livehost.com/v1",
  uat: "https://laundrygoappsuat.24livehost.com/v1",
  live: "https://laundryapp.24livehost.com/v1",
  prod: "https://api.laundrygo.com.au/v1",
};

const DEFAULT_ENV = "uat";

const requestedEnv = (process.env.REACT_APP_ENV || DEFAULT_ENV)
  .trim()
  .toLowerCase();

const APP_ENV = API_HOSTS[requestedEnv] ? requestedEnv : DEFAULT_ENV;

if (APP_ENV !== requestedEnv) {
  console.warn(
    `[config] Unknown REACT_APP_ENV "${requestedEnv}". Falling back to "${DEFAULT_ENV}". ` +
      `Valid values: ${Object.keys(API_HOSTS).join(", ")}`,
  );
}

const BASE_URL = process.env.REACT_APP_API_BASE_URL || API_HOSTS[APP_ENV];

const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  "AIzaSyAWZjAcfkw5mw3EAbSB1RUAOUERlAQzHL4"; // google api key given by client

export { API_HOSTS, APP_ENV, BASE_URL, GOOGLE_API_KEY };
